/* Deep-link actions the property Suites view (SuitesTable) consumes on mount to auto-open a bulk
 * dialogue. Produced by the suite-level "manage from property" walkthrough callout — producer and
 * consumer share these values so the ?action= contract can't drift. Values match the corresponding
 * SuiteActionSelect option values. */
export const SUITE_ACTION_PARAM = 'action';

export const SUITE_DEEP_LINK_ACTION = {
  addWalkthroughs: 'bulk-walkthroughs',
  activateWalkthroughs: 'bulk-activate-walkthroughs',
} as const;

export type SuiteDeepLinkAction =
  (typeof SUITE_DEEP_LINK_ACTION)[keyof typeof SUITE_DEEP_LINK_ACTION];